import React from 'react';

import { Switch } from '@headlessui/react';

interface ToggleSwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    onClick?: (event: React.MouseEvent) => void;
    className?: string;
}

const ToggleSwitch = ({
    checked,
    onChange,
    onClick,
    className = '',
}: ToggleSwitchProps) => {
    return (
        <Switch
            checked={checked}
            onChange={onChange}
            onClick={onClick}
            className={`${checked ? 'bg-peppermint-500' : 'bg-neutral-100'} 
                        ${className} group relative flex h-6 w-10 cursor-pointer rounded-full p-1 transition-colors duration-200 ease-in-out`}
        >
            <span
                aria-hidden='true'
                className={`${checked ? 'translate-x-4' : 'translate-x-0'} 
                            inline-block h-4 w-4 bg-monochrome-100 transform rounded-full transition-transform duration-200 ease-in-out`}
            />
        </Switch>
    );
};

export default ToggleSwitch;
